module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Attendance-Leaves/leave-sanction/leave-sanction-grid/leave-sanction-grid.component.css
// module id = ./src/app/hrms/Attendance-Leaves/leave-sanction/leave-sanction-grid/leave-sanction-grid.component.css
// module chunks = main